module.exports = __webpack_public_path__ + "img/T19.fb0dcd74.jpg";